import Contagem from "@pages/Contagem/Contagem";

export default Contagem;
